import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ComponentPropsWithoutRef, CSSProperties } from 'react';

// 密碼欄 + 可視切換(眼睛)。drop-in 取代 <input type="password">:
// 其餘 props 原樣傳進 input;呼叫端的 style 作用在外層(寬度/間距語意不變),
// input 固定撐滿外層並預留右側按鈕空間。未切換時恆為 type="password",
// 既有 E2E 的 input[type="password"] 選擇器不受影響。
export function PasswordInput({ style, ...inputProps }: ComponentPropsWithoutRef<'input'>) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const wrapStyle: CSSProperties = { position: 'relative', display: 'block', ...style };
  return (
    <span style={wrapStyle}>
      <input
        {...inputProps}
        type={show ? 'text' : 'password'}
        style={{ width: '100%', paddingRight: 42, boxSizing: 'border-box' }}
      />
      <button
        type="button"
        className="pw-toggle text-secondary"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? t('shell.password.hide') : t('shell.password.show')}
        aria-pressed={show}
        title={show ? t('shell.password.hide') : t('shell.password.show')}
      >
        {show ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </span>
  );
}

function EyeIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 3.19" />
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
}
